import React, { useState } from 'react';
import { View, Text } from 'react-native';
import theme from '../../theme';
import FaqItem from './FaqItem';

export function Faq ({data, header}) {

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <View style={{ paddingTop: 60, paddingBottom: 80, paddingHorizontal: 48, maxWidth: 760, width: '100%', alignSelf: 'center' }}>
      <Text
        style={{
          fontFamily: theme.typography.fontDisplay,
          fontWeight: theme.typography.weight.regular,
          fontSize: theme.typography.size['2xl'],
          letterSpacing: theme.trackingPx(theme.typography.size['2xl'], 'tight'),
          marginBottom: 24,
        }}
      >
        {header}
      </Text>
      {data.map((f, i) => (
        <FaqItem key={f.q} q={f.q} a={f.a} open={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} />
      ))}
    </View>
  );
}